import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class OpenLogFolderMessage extends WebViewMessage {
  public constructor() {
    super(MessageType.OpenLogFolder);
  }
}
